(function () {
    angular.module('ui2.0Service').factory('cliCommonService', ['$http', '$timeout', '$routeParams', function ($http, $timeout, $routeParams) {

        return {
            mountCliTemplatePopup: mountCliTemplatePopup,
            loadContractLineItemComponent,
            fetchAllTemplates,
        }

        function mountCliTemplatePopup(scope, mountAt, loadDefault) {
            if (scope && !scope.multiTableViewAllowed && mountAt != 'contract-template-popup') {
                scope.addLineItemHandler(true);
                return;
            }

            if((!scope.allTables && !scope.allTemplates) || (scope.allTables && scope.allTemplates && scope.allTemplates?.length === scope.allTables?.length)) {
                if(!scope.allTemplates || scope.allTemplates.length === 0) {
                    Toaster.create(intl_msg[35394] || "No template is present", {iconClass:"icon-Information_filled"});
                } else if(!loadDefault) {
                    Toaster.create(intl_msg[35395] || "All tables are already present", {iconClass: "icon-Information_filled"});
                }
                return;
            }

            const propsToPass = {
                entityTypeId: _.get(scope.data, "entityTypeId.values"),
                entityId: _.get(scope.data, "id.values"),
                allTemplates: scope.allTemplates ? JSON.parse(JSON.stringify(scope.allTemplates)) : [],
                allTables: scope.allTables || [],
                modalTitle: (mountAt == 'contract-template-popup') ? (intl_msg[34690]|| 'Select Template') : 'Table Details',
                modalFor: (mountAt == 'contract-template-popup') ? 'tblcontracttemplate' : 'tblcdr',
                loadDefault
            };
            mountAt = '#' + mountAt;
            let interval = setInterval(() => {
                if ($(mountAt).length) {
                    clearInterval(interval);
                    if (!$(mountAt).children().length) {
                        window.reactComponents.mountDynamicComponent(mountAt, "CliTemplatePopup", propsToPass);
                    }
                }
            }, 10)
        }

        function loadContractLineItemComponent(obj){
            let sc = $('ng-view').scope();
            let entityTypeId = urlToCodeMapper[$routeParams.entityName];
            let entityId = parseInt($routeParams.entityId);
            let isCrcTab = sc.data.isCrcTab;
            if (!_.isEmpty(obj)) {
                const mTabId = `#tab_${obj.id}`;
                sc.reactTableCardsLoaded = true;
                $(mTabId).addClass("react_container");
                let propsToPass = {
                    entityId,
                    entityTypeId,
                    globalData: sc.globalData,
                    showPageData: sc.data,
                    isCrcTab,
                    tabId: obj.id
                };
                const mountAt = '#contract_line_item_comp';
                let interval = setInterval(() => {
                    if ($(mountAt).length) {
                        clearInterval(interval);
                        window.reactComponents.mountDynamicComponent(mountAt, "CardsTable", propsToPass);
                    }
                })
            }
        };
        function preProcessTemplateData(data, scope) {
            scope.templateIdNameMap = {};
            const processedData = _.reduce(data, (acc, template) => {
                const {name, id} = template;
                const tableColumns = _.get(JSON.parse(_.get(template, "entityRawDataMetadata.metadata") || '[]'), "[0].metadata") || [];
                scope.templateIdNameMap[id] = name && name.trim();
                const obj = Object.assign({}, template);
                const columnsAsString = _.reduce(tableColumns, (acc, column, index) => {
                    acc = index ? (acc + ', ' + column.columnName) : column.columnName;
                    return acc;
                }, '');
                Object.assign(obj, {
                    tableColumns,
                    columnsAsString,
                    value: JSON.stringify({id, name}),
                    readMore: false
                })
                acc.push(obj);
                return acc;
            }, []);

            return processedData;
        }

        function getAllTemplates(args) {
            const that = this;
            const {entityTypeId, entityId, url} = args || {};
            return new Promise((resolve, reject) => {
                if (entityTypeId) {
                    $http.get(url).then(response => {
                        const processedData = preProcessTemplateData(response.data, that);
                        resolve(processedData);
                    })
                } else resolve(false);
            })
        };

        function fetchAllTemplates($scope, templateFor, callback) {
            const entityTypeId = _.get($scope.data, "entityTypeId.values");
            const entityId = _.get($scope.data, "id.values");
            let url = addtStamp(`/rawdata/alltemplates/${entityTypeId}?entityId=${entityId}`, true);
            if (templateFor == "tblcontracttemplate") {
                url = addtStamp(`/rawdata/alltemplates/160`, true);
            }
            getAllTemplates.call($scope, {entityTypeId, entityId, url}).then(data => {
                if (data) {
                    $scope.allTemplates = data;
                    let propsToPass = {
                        allTemplates: $scope.allTemplates,
                        existingTemplate: $scope.existingTemplate
                    }
                    SirionUtils.openReactModalFromAngular('#dm-line-item', propsToPass, 'updateLineItemComponent', "LineItemDetails", 'lineItemDetailsChannel', 'lineItemDetailsChannelSubscription');
                    $scope.defaultTemplate = $scope.allTemplates.find(template => template.defaultTemplate);
                    callback && callback($scope.defaultTemplate);
                }
            })

        }
    }]);
})();
